import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core';

export default function NewRecordButton(props) {
  let history = useHistory();
  const match = useRouteMatch();
  const theme = useTheme();
  return (
    <Button
      disabled={props.disabled}
      variant="contained"
      size={props.size}
      startIcon={<AddIcon />}
      style={{
        color: theme.palette.text.main,
        backgroundColor: theme.palette.primary.main,
      }}
      onClick={() => {
        history.push(`${match.url}/nuovo`);
      }}
    >
      {props.label === null || props.label === undefined
        ? 'Nuovo'
        : props.label}
    </Button>
  );
}

NewRecordButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};
